import { render, staticRenderFns } from "./ScenarioDetailLight.vue?vue&type=template&id=55abed0c"
import script from "./ScenarioDetailLight.vue?vue&type=script&lang=js"
export * from "./ScenarioDetailLight.vue?vue&type=script&lang=js"
import style0 from "./ScenarioDetailLight.vue?vue&type=style&index=0&id=55abed0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports